// Chakra imports
import { Flex, FormLabel, FormControl,Input, Text, useColorModeValue } from '@chakra-ui/react';


import InputField from "components/fields/InputField";

export default function Header(props: {
	[x: string]: any;
	data: any;
}) {
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = 'secondaryGray.600';

    if (props.data === undefined)        
        return (
            <></>
        );
        

	return (
		<FormControl mt='15px' >
            <Flex >
                <Flex direction='column' mb='30px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputBlNumber'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        B/L Número
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputBlNumber'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.expbl}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
                <Flex direction='column' mb='30px' ml='15px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputBuque'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Buque
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputBuque'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.buque}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
            </Flex>
            <Flex >
                <Flex direction='column' mb='30px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputBlNumber'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Viaje
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputBlNumber'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.viaje}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
                <Flex direction='column' mb='30px' ml='15px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputBuque'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Puerto de Carga
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputBuque'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.puertoori}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
            </Flex>
            <Flex >
                <Flex direction='column' mb='30px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputDuertoDescarga'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Puerto de Descarga
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputDuertoDescarga'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.puertodest}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
                <Flex direction='column' mb='30px' ml='15px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputFechaArribo'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        {props.data.labelFecha}
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputFechaArribo'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.fechaeta_String}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
            </Flex>
            <Flex >
                <Flex direction='column' mb='30px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputConsignatario'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Consignatario
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputConsignatario'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.nombreconsiG1}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
                { props.data.mostrarRegistro ?
                <Flex direction='column' mb='30px' ml='15px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputReG_SIDUENA'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Registro de Sidunea
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputReG_SIDUENA'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.reG_SIDUENA}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
                : <></>
                }
                { props.data.mostrarAlmacen ?
                <Flex direction='column' mb='30px' ml='15px'>
                    <FormLabel
                        display='flex'
                        ms='10px'
                        htmlFor='inputAlmacen'
                        fontSize='sm'
                        color={textColorPrimary}
                        fontWeight='bold'
                        _hover={{ cursor: 'pointer' }}>
                        <Text fontSize='sm' fontWeight='900' ms='2px'>
                        Almacén
                        </Text>
                    </FormLabel>
                    <Input
                        id='inputAlmacen'
                        isDisabled
                        fontWeight='500'
                        variant='main'
                        value={props.data.almacen}
                        h='44px'
                        maxH='44px'
                    />
                </Flex>
                : <></>
}
            </Flex>
        </FormControl>
	);
}
